import { Constants } from "../constants";

const initialState = {
  message: null,
  className: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.FLASH_MESSAGE:
      return action.payload;
    case Constants.FLASH_MESSAGE_CLEAR:
      return initialState;
    default:
      return state;
  }
};
